export default function prettyDateString(epochTime: any): string {
  const epochTimeInt = Number(epochTime);
  return new Date(epochTimeInt).toLocaleString();
}
